import { render, staticRenderFns } from "./DailyTxFees.vue?vue&type=template&id=6d3b4c7e&scoped=true&"
import script from "./DailyTxFees.vue?vue&type=script&lang=js&"
export * from "./DailyTxFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3b4c7e",
  null
  
)

export default component.exports